/***
*
*   CAMPAIGN
*   Information for user to get help and support
*
**********/

import React, { Fragment } from 'react';

export function Automation(props){

  return (
    <Fragment>

      {/* <Message 
        title='Need Help?'
        type='info'
        text="Contact our support team below. You can also enable or disable permission for our support team to access your account to help resolve any issues."
      /> */}

      
    </Fragment>
  )
}